module.exports = {"TXTCLI_LoadingXX":{"id":"TXTCLI_LoadingXX","defaultMessage":"En cours de chargement...","flags":["TRACK"],"track":"Loading..."}}